import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { autosubmit: { type: Boolean, default: false } }

  connect() {
    if (this.autosubmitValue) this.element.requestSubmit()
  }

  submit() {
    this.element.requestSubmit()
  }
}
